import { render, staticRenderFns } from "./DeckHistogram.vue?vue&type=template&id=c92de59e&"
import script from "./DeckHistogram.vue?vue&type=script&lang=js&"
export * from "./DeckHistogram.vue?vue&type=script&lang=js&"
import style0 from "./DeckHistogram.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports